import styled from "styled-components";
import { ComponentTitle } from "App/styles";

// `ComponentTitle` no trae margen propio (lo usan páginas públicas que lo
// acomodan por su cuenta), así que acá el subtítulo quedaba pegado al borde de
// la tarjeta de filtros.
export const SubTitle = styled(ComponentTitle)`
  margin: 4rem 0 1.2rem;
`;
